import { RefundType } from '@Encore-FastStartup-Phase-Out/encore-shared';
import moment from 'moment';
import 'moment-timezone';

export const endpoints = {
  users: {
    base: '/admin/users',
    checkUsername: '/admin/users/check-username',
    checkEmail: '/admin/users/check-email',
    byId: (id: string) => `/admin/users/${id}`,
    enableDisable: (id: string) => `/admin/users/${id}/enable-disable-seller`,
    approve: (id: string) => `/admin/users/${id}/approve`,
    reject: (id: string) => `/admin/users/${id}/reject`,
    sellerFee: (id: string) => `/admin/users/${id}/seller-fee`,
    featureById: (id: string) => `/admin/users/${id}/feature`,
    username: (id: string) => `/admin/users/${id}/username`,
    email: (id: string) => `/admin/users/${id}/email`,
    allMessages: (id: string) => `/admin/users/all-messages/${id}`,
    allBids: (id: string) => `/admin/users/all-bids/${id}`,
    isEbayAccountConnected: (id: string) =>
      `/admin/users/ebay-account-connected/${id}`,
  },
  speedMessages: {
    base: '/admin/speed-messages',
    byId: (id: string) => `/admin/speed-messages/${id}`,
  },
  listings: {
    base: '/admin/listings',
    active: '/admin/listings/active',
    sold: '/admin/listings/sold',
    soldById: (id: string) => `/admin/listings/sold/${id}`,
    activeById: (id: string) => `/admin/listings/active/${id}`,
    orderById: (id: string) => `/admin/listings/order/${id}`,
    cancelById: (id: string) => `/admin/listings/cancel-order/${id}`,
    featureById: (id: string) => `/admin/listings/feature/${id}`,
    flashSaleWindow: `/admin/listings/flash-sale-window`,
    eventGroups: `/admin/listings/events-groups/${moment.tz.guess()}`,
    eventListings: `/admin/listings/event-listings`,
    bulkUpdate: '/admin/listings/bulk-update',
    deleteAllUserActiveListings: (userId: string) =>
      `/admin/listings/all-active/${userId}`,
    enablePosting: '/admin/listings/enable-posting',
    enablePurchasing: '/admin/listings/enable-purchasing',
    getCrossListStatus: (id: string) =>
      `/admin/listings/cross-list/status/${id}`,
    crossList: (id: string) => `/admin/listings/cross-list/${id}`,
    retryCrossList: (id: string) => `/admin/listings/cross-list/retry/${id}`,
  },
  statistics: {
    base: '/admin/statistics',
  },
  subcategory: {
    base: '/admin/subCategory',
  },
  category: {
    base: '/category',
  },
  ratings: {
    base: '/admin/ratings',
    all: '/admin/ratings/all',
    delete: (id: string) => `/admin/ratings/soft-delete/${id}`,
  },
  chat: {
    base: '/admin/chat',
    allChats: '/admin/chat/all-chats',
    deleteChat: (id: string) => `/admin/chat/soft-delete-chat/${id}`,
    allMessages: '/admin/chat/all-messages',
    deleteMessage: (id: string) => `/admin/chat/soft-delete-message/${id}`,
  },
  auctionMessages: {
    base: '/admin/auction-messages',
    active: '/admin/auction-messages/active',
    delete: (id: string) => `/admin/auction-messages/soft-delete/${id}`,
  },
  transactions: {
    base: '/admin/transactions',
    orderTransactions: (id: string) =>
      `/admin/transactions/order-transactions/${id}`,
    orderRefundRemaining: (id: string, type: RefundType) =>
      `/admin/transactions/order-refund-remaining/${id}/${type}`,
    orderRefund: (id: string) => `/admin/transactions/order-refund/${id}`,
    autoPayout: (id: string) => `/admin/transactions/order/${id}`,
    orderPayout: (id: string) => `/admin/transactions/order-payout/${id}`,
    createAdminTransaction: '/admin/transactions/admin-transaction',
  },
  credit: {
    base: '/admin/credit',
    initialValue: '/admin/credit/initial-value',
    referralValue: '/admin/credit/referral-value',
    enableBoosters: '/admin/credit/enable-boosters',
  },
};
